import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import ArticleCard from '../ArticleCard/ArticleCard';
import routes from '../../../config/routes';

const BlogCardListing = ({ cardData, column }: any) => {
  return (
    cardData &&
    cardData.length > 0 && (
      <div className="blog-card-listing">
        <Container>
          <Row xl={column} lg={2} sm={1} xs={1}>
            {cardData.map((item: any, i: number) => {
              return <ArticleCard item={item} key={i} baseUrl={`${routes.blogsUrl}/`} />;
            })}
          </Row>
        </Container>
      </div>
    )
  );
};

BlogCardListing.propTypes = {
  cardData: PropTypes.any.isRequired,
  column: PropTypes.number.isRequired
};

export default BlogCardListing;
